import { ApiClient } from "../../lib/ApiClient";
import { useGenericSWR } from "../../lib/useGenericSWR";

const apiClient = new ApiClient();
const apiEndpoint = '/identity/account';

const useLogin = (returnUrl, swrOptions = {}) => {
    const params = new URLSearchParams();
    params.append('returnUrl', returnUrl);

    return useGenericSWR(apiEndpoint + "/login?" + params.toString(), apiClient, { ...swrOptions });
};


export {
    useLogin
};